import { App, Poller } from '@gin-betting/core';
import matchList from '@gin-betting/match-list';
import cd from 'debug';
import React, { Fragment, ReactElement } from 'react';

import { AsyncMobileFilters } from 'modules/filters/async';
import { MatchListType } from 'app-constants';
import { MobileTopMenu } from 'views/top-menu';
import { ListHelmet } from 'components';
import Upcoming from './Upcoming/Upcoming';
import Results from './Results/Results';
import LiveList from './LiveList';
import PrematchList from './PrematchList';
import useMatchListContainer from './useMatchListContainer';
import './matchListContainer.scss';

interface Props {
    type: MatchListType;
    fetchStatus: App.FetchStatus;
    poller: Poller.Poller<typeof matchList.actions.searchMatches>;
}

const MATCH_LIST_COMPONENTS_BY_TYPE: Record<MatchListType, ReactElement> = {
    [MatchListType.LIVE]: <LiveList />,
    [MatchListType.RESULTS]: <Results />,
    [MatchListType.UPCOMING]: <Upcoming />,
    [MatchListType.PREMATCH]: <PrematchList />,
};

const debug = cd('app:match-list:components:MatchListContainer');

const MatchListContainer: React.FC<Props> = props => {
    debug('render', props);

    const { type, poller, fetchStatus } = props;

    const {
        isBettingPage,
        isCompact,
        shouldRenderMatchList,
    } = useMatchListContainer({
        poller,
    });

    return (
        <Fragment>
            {isBettingPage && isCompact && (
                <Fragment>
                    <div styleName="wrapper-top-menu">
                        <MobileTopMenu fetchStatus={fetchStatus} />
                    </div>
                    <AsyncMobileFilters />
                </Fragment>
            )}

            {isBettingPage && window.__app.previousLocation && <ListHelmet />}

            {shouldRenderMatchList && MATCH_LIST_COMPONENTS_BY_TYPE[type]}
        </Fragment>
    );
};

export default MatchListContainer;
